import {Envelope} from '~/src/utilities/types/api';

import {getClientId} from '~/src/utilities/helpers/client';
import {postJsonRequest, deleteRequest, getJsonRequest, patchRequest} from '~/src/utilities/helpers/request';

const requestOptions = (addContentType = false) => {
    let options = {};

    // TODO : Remove server static client id, if the comment can be called from the server too, without the client id
    if (process.browser) {
        options = {
            cache: 'no-cache',
            headers: {
                'X-20min-Client-Token': getClientId()
            }
        };
    } else {
        options = {
            cache: 'no-cache',
            headers: {
                'X-20min-Client-Token': 'V1StGXR8_Z5jdHi6B-myT'
            }
        };
    }

    if (addContentType) {
        options.headers['Content-Type'] = 'application/json';
    }

    options.credentials = 'include';

    return options;
};

const getApiRequest = async (url, returnsEnvelope = false) => {
    const options = requestOptions();
    const response = await getJsonRequest(url, options);
    return returnsEnvelope ? new Envelope(response) : response;
};

const postApiRequest = async (url, data, returnsEnvelope = false) => {
    const options = requestOptions(true);
    const response = await postJsonRequest(url, options, data);
    return returnsEnvelope ? new Envelope(response) : response;
};

const patchApiRequest = (url, data) => {
    const options = requestOptions(true);
    return patchRequest(url, options, data);
};

const deleteApiRequest = (url) => {
    const options = requestOptions();
    return deleteRequest(url, options);
};

export {getApiRequest, postApiRequest, patchApiRequest, deleteApiRequest};
